import {FormGroup} from '@angular/forms';
import {Injectable} from '@angular/core';
@Injectable()
export class FormUtilities {
  /**
   * Marks a form as pristine so as to disable the form submission button
   * Source: https://stackoverflow.com/questions/40690371/angular-2-set-form-to-pristine-without-clearing-data
   * @param {FormGroup} form
   */
  public markFormPristine(form: FormGroup) {
    Object.keys(form.controls).forEach(control => {
      form.controls[control].markAsPristine();
    });
  }

  public markFormTouched(form: FormGroup) {
    Object.keys(form.controls).forEach(control => {
      form.controls[control].markAsTouched();
    });
  }

  isInvalidAndTouched(form: FormGroup, formControlName: string) {
    if (!form.controls[formControlName])
      return false;
    return !form.controls[formControlName].valid && form.controls[formControlName].touched;
  }

  isTouchedAndHasError(form: FormGroup, formControlName: string, errorCode: string) {
    if (!form.controls[formControlName])
      return false;
    return form.controls[formControlName].hasError(errorCode) && form.controls[formControlName].touched
  }

  createUUID() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  getBase64(file): Promise<string> {
    return new Promise(function (resolve, reject) {
      const reader = new FileReader();
      reader.onload = function () {
        resolve(reader.result);
      };
      reader.onerror = reject;
      reader.readAsDataURL(file);
    });
  }

  protected validateFileUpload(file: File, validFileExtensions: string[]) {
    const fileExtension = file.name.toLowerCase().split('.').pop();
    return validFileExtensions.includes('.' + fileExtension);
  }

  public chooseFile(listOfFileTypes: string[]): Promise<File> {
    return new Promise((resolve, reject) => {
      const uploadHtmlElement = document.createElement('INPUT');
      uploadHtmlElement.setAttribute('type', 'file');
      uploadHtmlElement.setAttribute('accept', listOfFileTypes.join(','));
      uploadHtmlElement.onchange = (uploadEvent) => {
        const fileList: FileList = (<HTMLInputElement>uploadEvent.target).files;
        if (!this.validateFileUpload(fileList[0], listOfFileTypes))
          reject();
        resolve(fileList[0]);
      };
      uploadHtmlElement.click();
    });
  }
}



// WEBPACK FOOTER //
// /var/www/dnata-cerf-front-end/releases/20200326161233/src/app/modules/utilities/FormUtilities.ts